import { render, staticRenderFns } from "./draggableChild.vue?vue&type=template&id=eb538238"
import script from "./draggableChild.vue?vue&type=script&lang=js"
export * from "./draggableChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports